import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper, TextField, Typography } from '@mui/material'
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import axios from 'axios'
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import _ from 'lodash'
import React, { Fragment, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers'
import dayjs from 'dayjs';
import moment from 'moment';
import CustomTable from '../customTable';

const WhClosingStockMissingReports = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const outletId = localStorage.getItem('outlet_id')
    const roleId = localStorage.getItem("role_id")
    const[cust, setCust] = useState(null)
    const [data,setData] = useState([])
    const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
    const [supplier, setSupplier] = useState([]);
    const [catData, setCatData] = useState([]);
    const [allSubData, setAllSubData] = useState([]);
    const [subData, setSubData] = useState([]);
    const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");

    const [dateLimit, setDateLimit] = useState({
        fromDate : roleId != 1 && roleId != 2 ? moment().format() : moment().startOf('month').format(),
        toDate :  moment().format()
      })
      const [openDialog, setOpenDialog] = useState(false);
      const [selectedRow, setSelectedRow] = useState(null);
      const [options, setOptions] = useState({
        category: null,
        subCategory: null,
      });
      function handleReactivate(row) {
        setSelectedRow(row);
        setOpenDialog(true);
    }
    const handleSearch = (e) =>{
      props.setSearch(e.target.value)
    }
    // function confirmReactivate(e) {
    //     axios.post('/v1/barcode/deactivate/ismissed', {
    //         outlet_id: outletId,
    //         is_missed: false,
    //         barcode: e.barcode
    //     })
    //     .then(() => {
    //         dispatch(setSnackbar(true, "success", "Item reactivated successfully"));
    //         closingStockReports(); // Refresh data
    //     })
    //     .catch((err) => {
    //         dispatch(setSnackbar(true, "error", err.response?.data.errors[0].message));
    //     })
    //     .finally(() => {
    //         setOpenDialog(false);
    //         setSelectedRow(null);
    //     });
    // }
    function confirmReactivate(e) {
      const barcodeValue = e?.barcode || selectedRow?.barcode;
  
      if (!barcodeValue) {
          dispatch(setSnackbar(true, "error", "Barcode is missing"));
          return;
      }
  
      axios.post('/v1/barcode/deactivate/warehouse/ismissed', {
          // outlet_id: outletId,
          is_missed: false,
          barcode: barcodeValue
      })
      .then(() => {
          dispatch(setSnackbar(true, "success", "Item reactivated successfully"));
          closingStockReports(); // Refresh data
      })
      .catch((err) => {
          dispatch(setSnackbar(true, "error", err.response?.data.errors[0].message));
      })
      .finally(() => {
          setOpenDialog(false);
          setSelectedRow(null);
      });
  }
  
    function handleChange(e, name) {
        setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
      }
      
      function handleChangeValue(value, name) {
        setOptions((prev) => ({ ...prev, [name]: value }));
        if (name === "category") {
          setOptions((prev) => ({ ...prev, subCategory: null }));
          filterSubCategories(value ? value.id : null);
        }
      }
      function filterSubCategories(categoryId) {
        if (categoryId) {
          const filteredSubData = allSubData.filter(
            (sub) => sub.category_id === categoryId
          );
          setSubData(filteredSubData);
        } else {
          setSubData([]);
        }
      }
      function getCategory() {
        axios
          .get("/v1/categories")
          .then((res) => {
            const activeCategories = _.filter(res.data, (val) => val.is_active);
            setCatData(activeCategories);
          })
          .catch((err) => {
            console.log(err);
            dispatch(setSnackbar(true, "error", err.response.data.error));
          });
      }
      function getSubCategory() {
        axios
          .get("/v1/subcategories")
          .then((res) => {
            setAllSubData(res.data);
          })
          .catch((err) => {
            console.log(err);
            dispatch(setSnackbar(true, "error", err.response.data.error));
          });
      }
    function getSupplierData() {
        axios
          .get("/v1/outlet/list/1")
          .then((res) => {
            _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
            setSupplier(res.data);
          })
          .catch((err) => {
            dispatch(setSnackbar(true, "error", err.response.data.error));
          });
      }
      const columns = [
        {
            field : 'sno',
            headerName:'S.no',
            minWidth:70,
            headerAlign:'center',
            align:'center',
            sortable:false
        },
        {
          field: "docDate",
          headerName: "Date",
          minWidth: 180,
          headerAlign: "center",
          align: "center",
          sortable: false,
      },
        {
            field: "barcode",
            headerName: "Barcode",
            minWidth: 180,
            headerAlign: "center",
            align: "center",
            sortable: false,
        },
        {
            field: "pro_name",
            headerName: "Product Name",
            minWidth: 200,
            flex:1,
            headerAlign: "center",
            align: "center",
            sortable: false,
        },
        {
            field: "category_name",
            headerName: "Category Name",
            minWidth: 200,
            headerAlign: "center",
            align: "center",
            sortable: false,
        },
        {
            field: "subcategory_name",
            headerName: "Subcategory Name",
            minWidth: 200,
            headerAlign: "center",
            align: "center",
            sortable: false,
        },
        {
            field: "mrp",
            headerName: "Mrp",
            minWidth: 200,
            headerAlign: "center",
            align: "center",
            sortable: false,
        },
        {
          field: "reactivate",
          headerName: "Reactivate",
          minWidth: 150,
          headerAlign: "center",
          align: "center",
          sortable: false,
          renderCell: (params) => (
              <Button variant="contained" size='small' sx={{ borderRadius: '120px',fontSize: 10 }} onClick={() => handleReactivate(params.row)} >
                  Reactivate
              </Button>
          )
      }
        

      ]
      const rows = _.map(data,(val,idx) =>({
        id: val.id,
        // id: idx,
        // sno: val.sno || null,
        sno:idx+1,
        docDate:moment(val.docdate).format('DD-MM-YYYY'),

        barcode: val.barcode,
        pro_name:val.pro_name,
        category_name:val.category_name,
        subcategory_name:val.subcategory_name,
        mrp: val.mrp
      }))
      const props = {
        columns : columns,
        rows : rows,
        page: page,
        search: search,
        setSearch: setSearch,
        setPage: setPage,
        rowsPerPage: rowsPerPage,
        setRowsPerPage: setRowsPerPage,
        pageCount: pageCount,
        pageOption: pageOption,
        totalAmount:totalAmount,
        totalFlag:totalFlag
      }
      useEffect(() => {
        // Calculate total balance amount
        setTotalFlag(true)
        let total = 0;
      
        data.forEach(val => {
            total += parseFloat(val.mrp);
        });
        setTotalAmount(total.toFixed(0));
      }, [data]);
      function closingStockReports(){
        setLoading(true);
        const closingData = {
            from_date : moment(dateLimit.fromDate).format('YYYY-MM-DD'),
            to_date : moment(dateLimit.toDate).format('YYYY-MM-DD'),
            customer:0,
            // search: search || '',
            // outlet_id:cust!==null ? cust.id : outletId,
        }
        axios.post(`/v1/reports/stock_missing/warehouse/new`,closingData )
        // axios.post(`/v1/reports/closing/stock/outlet/missing`,closingData )
        .then(res=>{
          setData(res.data)
          setPageCount(res.data.length)
         
          console.log(res.data,"response1213");
          
        })
        .catch(err=>{
            console.log(err)
          // dispatch(setSnackbar(true, "error", err.response?.data.errors[0].message));
          setData([])
          
        })
        .finally(() => {
          setLoading(false); // Stop loading after request
        });
      }
      useEffect(() => {
        getSupplierData();
        getCategory();
        getSubCategory();
      }, []);
      useEffect(() => {
        if (options.category) {
          filterSubCategories(options.category.id);
        }
      }, [options.category]);
      useEffect(() => {
        closingStockReports()
      },[rowsPerPage, page, dateLimit, cust , options,search])
  return (
    <Fragment>
        <Helmet><title>WareHouse Closing Stock Missing Reports</title></Helmet>
      <Typography variant="h6">WareHouse Closing Stock Missing Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              // disabled={roleId != 1 && roleId != 2} 
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'},
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format="DD-MM-YYYY"
              // disabled={roleId != 1 && roleId != 2} 
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        {/* <Grid item md={3}>
          <Autocomplete 
            size="small"
            value={cust}
            options={supplier}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname} 
            disabled={roleId != 1 && roleId != 2} 
            renderInput={(params) => <TextField {...params} label="Select Outlet"
            InputProps={{
              ...params.InputProps,
              readOnly: true,
            }}  
            />}
          />
        </Grid> */}
        <Grid item md={3}>
          <TextField size="small" placeholder= "search"              onChange={(e) => setSearch(e.target.value)}
          />
        </Grid>
      </Grid>
      {/* <CustomTable props={props}/> */}
      <Box position="relative" width="100%">
        {/* Table Container */}
        <Paper elevation={2}>
        <CustomTable props={props}/>
        </Paper>
        
        {/* Loader Overlay */}
        {loading && (
          <Box 
            display="flex" 
            justifyContent="center" 
            alignItems="center" 
            position="absolute" 
            top={0} 
            left={0} 
            right={0} 
            bottom={0} 
            bgcolor="rgba(255, 255, 255, 0.7)" // Optional: background color for the overlay
            zIndex={1}
          >
            <CircularProgress size={50}/> {/* Material UI spinner */}
          </Box>
        )}
      </Box>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
      <Grid className='bg-white p-5'>
            <Typography variant='h5'>Are you sure you want to reactivate this item?</Typography>
            <Grid className='flex justify-center mt-5'>
                <Button variant='outlined' onClick={() => setOpenDialog(false)}>Cancel</Button>
                <div>
                    <Button
                        variant='contained'
                        sx={{ marginInline: 2, backgroundColor: 'red !important' }}
                        onClick={confirmReactivate} 
                    >
                        Confirm
                    </Button>
                </div>
            </Grid>
        </Grid>
                {/* <DialogTitle>Reactivate Item</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to reactivate this item?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} color="secondary">Cancel</Button>
                    <Button onClick={confirmReactivate} color="primary">Confirm</Button>
                </DialogActions> */}
            </Dialog>
    </Fragment>
  )
}

export default WhClosingStockMissingReports